

export const resetCreateNewWorkerReducer = (state:any) => {
    state.createNewWorker.status = "idle";
    state.createNewWorker.errorMessage = "";
  }